export const PREMIUM = {
  MONTH_1: 'premium_1_month',
  MONTH_3: 'premium_3_month',
  MONTH_12: 'premium_12_month',
  MONTH_12_AND_CRYSTALS_10000: 'premium_12_month_and_10000_crystals',
}